import { ColorPicker, UpsellGuard } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useTrackInvoicingSettings } from '@features/invoicingSettings/hooks/useTrackInvoicingSettings'

import { Scope } from '../../../../../../../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../../../../../../../enums/trackingContext'
import { useFormContext } from '../../../../../../../../../../../../../../hooks'
import { InvoiceSettingsFormSchema } from '../../../../../../../../types/invoiceSettingsFormSchema'

export const DefaultColor = (): ReactElement => {
  const { t } = useTranslation()
  const { trackInvoicingSettings } = useTrackInvoicingSettings()
  const {
    trigger,
    formState: { errors },
    FormItem,
  } = useFormContext<InvoiceSettingsFormSchema>()

  return (
    <FormItem
      name="templateColor"
      label={t('settings.organization.external_invoice.appearance.default_color.label')}
      render={({ field: { onChange, value } }) => {
        return (
          <UpsellGuard scope={Scope.InvoiceDesignerUpsell} trackingContext={TrackingContext.InvoiceDesigner}>
            <ColorPicker
              isError={!!errors.templateColor}
              onChange={(props) => {
                onChange(props)
                trigger('templateColor')
                trackInvoicingSettings('Color changed')
              }}
              value={value}
            />
          </UpsellGuard>
        )
      }}
    />
  )
}
